import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { DisplayRuleStateMap } from '@/features/displayRules';
import ExpEngine from '@/services/ExpEngine';

export const getDisplayRulesMetadata = (displayRules: DisplayRuleStateMap, screen: ScreenRef, action: ActionRef) => {
  const key = ExpEngine.getDisplayRuleService().getDisplayRuleKey(screen, action);
  const displayRule = displayRules[key];
  return displayRule ? displayRule.currentMetadata || null : null;
};
